
import { defineComponent, onMounted, onUnmounted } from 'vue'
import { salesClosed, registrationClosed } from '@/utils/ServiceAvailability'
import { startMemberActivityTracking } from '@/utils/MemberActivity'

export default defineComponent({
  setup() {
    let stop: (() => void) | undefined
    onMounted(() => { stop = startMemberActivityTracking() })
    onUnmounted(() => { if (stop) stop() })
    return { salesClosed, registrationClosed }
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
  },
})
